export default __webpack_public_path__ + "static/media/buttonsSolution.98cbef18.png";